export default __webpack_public_path__ + "static/media/check.11fe49aa.svg";